export default {
    loading: 'Chargement',
    search : 'Rechercher',
}



// WEBPACK FOOTER //
// ./resources/assets/js/i18n/fr.js